import { fieldIsValid } from "../../../../../lib/helper";
import { Toggle } from "../../../../../../common/Atoms/Toggle";

import { IFieldProps } from "./fieldProps";

export function SkipWhenPromisedOrQueryOpen({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  return (
    <>
      <Toggle
        label={ `Skip when payment promised` }
        helpIcon={ `Policies scheduled after the promised date still run. Promised date policies are never skipped.` }
        checked={ policyFormData.skip_when_payment_promised ?? true }
        onChange={ handleChange }
        name={ `skip_when_payment_promised` }
        description={ `Skip this policy while the customer has an open payment promise and it would run before the promised date.` }
        invalid={ fieldIsValid(`skip_when_payment_promised`, invalids) }
      />
      <Toggle
        label={ `Skip while a query is open` }
        checked={ policyFormData.skip_when_query_open ?? true }
        onChange={ handleChange }
        name={ `skip_when_query_open` }
        description={ `Skip this policy while the invoice has an open query.` }
        invalid={ fieldIsValid(`skip_when_query_open`, invalids) }
      />
    </>
  );
}
